// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"524":"1114d6faf1c52e15aa38","833":"c0aa152ffc42288a6351","913":"0341f92c61c8a98b8702","926":"80f1bae5b34c0ed5ca2a"}[chunkId] + ".chunk.js";
};